import React from "react";
import styled, { keyframes } from "styled-components";

const Home = () => {
  return (
    <HomeContainer>
      <HeroSection>
        <Overlay />
        <HeroText>
          <h1>Unfamiliar People</h1>
          <p>Uniting people, empowering change. Together, we make a difference.</p>
          <HeroButton href="/donate">Make an Impact</HeroButton>
        </HeroText>
      </HeroSection>
      <MissionSection>
        <h2>Our Mission</h2>
        <p>
          We support causes that matter. No matter the need, Unfamiliar People stands for change, action, and unity.
        </p>
      </MissionSection>
    </HomeContainer>
  );
};

export default Home;

// Styled Components
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const HomeContainer = styled.div`
  text-align: center;
  color: #ffffff;
`;

const HeroSection = styled.div`
  background: url("https://source.unsplash.com/1600x900/?community,helping") no-repeat center center/cover;
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4); /* Dark overlay for readability */
`;

const HeroText = styled.div`
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(5px);
  padding: 40px;
  border-radius: 10px;
  max-width: 600px;
  text-align: center;
  animation: ${fadeIn} 1s ease-out;

  h1 {
    font-size: 3.5rem;
    font-weight: bold;
    margin-bottom: 10px;
  }

  p {
    font-size: 1.4rem;
    margin-bottom: 20px;
  }
`;

const HeroButton = styled.a`
  background: #ffd700;
  color: black;
  padding: 14px 28px;
  font-size: 1.2rem;
  font-weight: bold;
  text-decoration: none;
  border-radius: 6px;
  transition: 0.3s ease-in-out;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  display: inline-block;
  animation: ${fadeIn} 1.5s ease-out;

  &:hover {
    background: #ffb300;
    transform: scale(1.05);
  }
`;

const MissionSection = styled.div`
  background: #fff;
  color: #000;
  padding: 80px 20px;

  h2 {
    font-size: 2.8rem;
    margin-bottom: 20px;
    font-weight: bold;
  }

  p {
    font-size: 1.2rem;
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.6;
  }
`;